import { getAttachmentPermissionLevelFromSharingLinkKind } from '../utils/getAttachmentPermissionLevelFromSharingLinkKind';
import { getSharingUrls } from '../utils/getSharingUrls';
import { getSupportedPermissionLevels } from '../utils/getSupportedPermissionLevels';
import { userDate } from 'owa-datetime/lib/userDate';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';

export default function createLinkModel(
    linkId: string,
    url: string,
    response: GetSharingInfoResponse | null
): SharingLinkInfo {
    if (!response || response.ResultCode !== AttachmentResultCode.Success) {
        return {
            linkId: linkId,
            fileName: null,
            mimeType: null,
            url: url,
            permissionLevel: AttachmentPermissionLevel.None,
            sharingInfo: {
                getSharingInfoSucceeded: false,
                canonicalUrl: '',
                canShareInternally: false,
                canShareExternally: false,
                expirationDate: null,
                ignoreExpirationDate: false,
                canRefreshExpiration: false,
                shareId: null,
                recipientPermissionInfos: [],
                hasDLRecipient: false,
            },
            supportedPermissionLevels: null,
            sharingUrls: null,
        };
    }

    return {
        linkId: linkId,
        fileName: response.FileName,
        mimeType: response.MimeType,
        url: url,
        permissionLevel: getAttachmentPermissionLevelFromSharingLinkKind(response.SharingLinkKind),
        sharingInfo: {
            getSharingInfoSucceeded: true,
            canonicalUrl: response.CanonicalUrl,
            canShareInternally: response.CanShareInternally,
            canShareExternally: response.CanShareExternally,
            expirationDate: response.ExpirationDate ? userDate(response.ExpirationDate) : null,
            ignoreExpirationDate: false,
            canRefreshExpiration: false,
            shareId: null,
            recipientPermissionInfos: [],
            hasDLRecipient: false,
        },
        supportedPermissionLevels: getSupportedPermissionLevels(response),
        sharingUrls: getSharingUrls(response),
    };
}
